import AUDITORIAS_INFORMES_POR_AUDITORIA from '@/graphql/querys/administracion/auditorias/auditoriasInformesPorAuditoria.gql';
import AGREGAR_AUDITORIA_INFORME from '@/graphql/mutations/administracion/auditorias/informes/agregarAuditoriaInforme.gql';
import REMOVER_AUDITORIA_INFORME from '@/graphql/mutations/administracion/auditorias/informes/removerAuditoriaInforme.gql';
import ACTUALIZAR_AUDITORIA_INFORME from '@/graphql/mutations/administracion/auditorias/informes/actualizarAuditoriaInforme.gql';
import AUDITORIAS from '@/graphql/querys/administracion/auditorias/auditorias.gql';
import mixSubirArchivo from '@/helpers/mixSubirArchivo';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.hermosillo.gob.mx';

export default {
  data() {
    return {
      progresoDescarga: null,
    };
  },
  apollo: {
    auditorias: {
      query: AUDITORIAS,
    },
  },
  mixins: [mixSubirArchivo],
  methods: {
    async mixAgregarAuditoriaInforme() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const { idAuditoria } = this.informe;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_AUDITORIA_INFORME,
          variables: { informe: this.informe },
          update: (store, { data: { agregarAuditoriaInforme } }) => {
            const data = store.readQuery({
              query: AUDITORIAS_INFORMES_POR_AUDITORIA,
              variables: { idAuditoria },
            });
            data.auditoriasInformesPorAuditoria.push(agregarAuditoriaInforme);
            store.writeQuery({ query: AUDITORIAS_INFORMES_POR_AUDITORIA, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      await this.$apollo.queries.auditorias
        .refetch();
      this.cerrar();
    },
    async mixEliminarAuditoriaInforme() {
      this.mixEsCargando();
      this.enviadoFormulario = true;
      const idAuditoriaInforme = this.informe.id;
      const { idAuditoria } = this.informe;
      await this.$apollo.mutate({
        mutation: REMOVER_AUDITORIA_INFORME,
        variables: {
          id: idAuditoriaInforme,
        },
        update: (store) => {
          const query = {
            query: AUDITORIAS_INFORMES_POR_AUDITORIA,
            variables: { idAuditoria },
          };
          const data = store.readQuery(query);
          const index = data.auditoriasInformesPorAuditoria
            .findIndex(({ id }) => id === idAuditoriaInforme);
          if (index !== -1) {
            data.auditoriasInformesPorAuditoria.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixActualizarAuditoriaInforme() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      const { idAuditoria } = this.informeEditar;
      await this.$apollo.mutate({
        mutation: ACTUALIZAR_AUDITORIA_INFORME,
        variables: {
          id: this.informeEditar.id,
          informe: this.informe,
        },
        update: (store, { data: { actualizarAuditoriaInforme } }) => {
          const data = store.readQuery({
            query: AUDITORIAS_INFORMES_POR_AUDITORIA,
            variables: { idAuditoria },
          });
          const { auditoriasInformesPorAuditoria } = data;
          const index = auditoriasInformesPorAuditoria
            .findIndex((auditoriaInforme) => auditoriaInforme.id === actualizarAuditoriaInforme.id);
          if (index !== -1) {
            auditoriasInformesPorAuditoria.splice(index, 1, actualizarAuditoriaInforme);
          }
          store.writeQuery({ query: AUDITORIAS_INFORMES_POR_AUDITORIA, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixGetPdf(publicKey) {
      return this.axios.get(
        `${BASE_URL}/${publicKey}`,
        {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.progresoDescarga = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
            }
          },
        },
      )
        .then((res) => ({
          data: res.data,
        }))
        .catch((err) => {
          this.mixMensajeError(err.data.message);
          return {
            err: err.data.message,
          };
        }).finally(() => {
          this.progresoDescarga = 0;
        });
    },
  },
};
